import noop from 'lodash/noop';
import { useCallback, useEffect } from 'react';

import { SocketEventHandlers, useSocketIO } from './useSocketIO';

interface RoomEventPayload {
    room: string;
    event: string;
    data?: unknown;
}

// Усовершенствованная версия useSocketIO – здесь не нужен дополнительный слой,
// проксирующий ивенты, значит быстрее и проще писать логику
export function useSocketRoom(room: RoomEventPayload['room'], eventHandlers?: SocketEventHandlers) {
    const { emit } = useSocketIO('/rooms', {
        event: (payload: RoomEventPayload) => {
            if (payload?.room === room) {
                eventHandlers?.[payload.event]?.(payload.data);
            }
        },
        // @ts-ignore
        connect: eventHandlers?.connect || noop,
    });

    useEffect(() => {
        emit('join', room);

        return () => emit('leave', room);
    }, [room, emit]);

    const roomEmit = useCallback(
        (event: RoomEventPayload['event'], data?: RoomEventPayload['data']) => {
            const payload: RoomEventPayload = { event, data, room };
            emit('event', payload);
        },
        [emit, room]
    );

    return {
        emit: roomEmit,
    };
}
